import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from 'halogen/PulseLoader';
import { injectIntl, intlShape } from 'react-intl';
import { Download, Plus } from '../../helpers/icon-dictionary';
import messages from './messages';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import { DARK } from '../button/variants';

const StudentHeader = ({ filteredStudentsCount = 0, isStudentDataLoaded = false, isStudentRollDownloaded = true,
    handleOnDownloadStudentRoll, handleQuickUpload, handleAddStudent, intl }) => {
    const studentsCount = isStudentDataLoaded
        ? <span>{filteredStudentsCount}</span>
        : <Loader color="#000" margin="2px" size="6px" />;
    return (
        <div className={css.studentHeaderComponent}>
            <div className={css.studentsCountContainer}>
                <span className={css.studentsTitle}>{intl.formatMessage(messages.students)}
                    <span className={css.studentsCount}>
                        ( {studentsCount} )
                    </span>
                </span>
            </div>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.downloadStudentRoll}
                    disabled={filteredStudentsCount === 0}
                    handleOnClick={handleOnDownloadStudentRoll}
                    icon={Download}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.downloadStudentRoll)}
                    loading={!isStudentRollDownloaded}
                    loadingLabel={intl.formatMessage(messages.downloading)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.bulkUpload}
                    disabled={false}
                    handleOnClick={handleQuickUpload}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.quickUpload)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.addStudent}
                    disabled={!isStudentDataLoaded}
                    handleOnClick={handleAddStudent}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.addStudent)}
                    variant={DARK}
                    visible />
            </div>
        </div>
    );
};

StudentHeader.propTypes = {
    isStudentDataLoaded: PropTypes.bool,
    isStudentRollDownloaded: PropTypes.bool,
    filteredStudentsCount: PropTypes.number,
    handleOnDownloadStudentRoll: PropTypes.func,
    handleQuickUpload: PropTypes.func,
    handleAddStudent: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(StudentHeader));



// WEBPACK FOOTER //
// ./app/components/student-header/index.js